function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "multimedia_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "multimedia_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#multimedia_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "music-and-multimedia-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "music-and-multimedia-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#multimedia_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 0.546875)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.78125 7.59064L0.78125 1.51077C0.78125 1.10855 1.10855 0.78125 1.51077 0.78125L18.4737 0.78125C18.8759 0.78125 19.2032 1.10855 19.2032 1.51077L19.2032 2.70615C19.2032 2.92175 19.3781 3.09677 19.5938 3.09677C19.8096 3.09677 19.9844 2.92175 19.9844 2.70615L19.9844 1.51077C19.9844 0.677795 19.3066 0 18.4737 0L1.51077 0C0.677795 0 0 0.677795 0 1.51077L0 7.59064C0 7.8064 0.174866 7.98126 0.390625 7.98126C0.606384 7.98126 0.78125 7.8064 0.78125 7.59064Z",
  transform: "translate(0.0078125 0)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2032 0.390625L19.2032 6.47064C19.2032 6.87286 18.8759 7.20016 18.4737 7.20016L1.51077 7.20016C1.10855 7.20016 0.78125 6.87286 0.78125 6.47064L0.78125 5.27527C0.78125 5.05951 0.606384 4.88464 0.390625 4.88464C0.174866 4.88464 0 5.05951 0 5.27527L0 6.47064C0 7.30362 0.677795 7.98141 1.51077 7.98141L18.4737 7.98141C19.3066 7.98141 19.9844 7.30362 19.9844 6.47064L19.9844 0.390625C19.9844 0.175018 19.8096 0 19.5938 0L19.5938 0C19.3781 0 19.2032 0.175018 19.2032 0.390625Z",
  transform: "translate(0.0078125 5.5029297)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.195313 0.0522995C0.0744629 0.122032 0 0.250969 0 0.390587L0 6.61983C0 6.75945 0.0744629 6.88839 0.195313 6.95812C0.255737 6.99306 0.323181 7.01046 0.390625 7.01046C0.458069 7.01046 0.525513 6.99306 0.585938 6.95812L5.98068 3.8435C6.10153 3.77377 6.17599 3.64483 6.17599 3.50521C6.17599 3.36575 6.10153 3.23681 5.98068 3.16692L0.585938 0.0522995C0.465088 -0.0174332 0.316162 -0.0174332 0.195313 0.0522995ZM0.78125 1.06716L5.00427 3.50521L0.78125 5.94341L0.78125 1.06716Z",
  transform: "translate(6.9121094 3.2363281)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.81946 1.78741L6.81946 1.41937C6.81946 0.636597 6.18286 0 5.40009 0C4.61746 0 3.98071 0.636597 3.98071 1.41937L3.98071 1.78741L0.390625 1.78741C0.174866 1.78741 0 1.96228 0 2.17804C0 2.3938 0.174866 2.56866 0.390625 2.56866L3.98071 2.56866L3.98071 2.93655C3.98071 3.71933 4.61746 4.35593 5.40009 4.35593C6.18286 4.35593 6.81946 3.71933 6.81946 2.93655L6.81946 2.56866L19.5938 2.56866C19.8096 2.56866 19.9844 2.3938 19.9844 2.17804C19.9844 1.96228 19.8096 1.78741 19.5938 1.78741L19.5938 1.78741L6.81946 1.78741ZM5.40009 3.57468C5.04822 3.57468 4.76196 3.28857 4.76196 2.93655L4.76196 1.41937C4.76196 1.06751 5.04822 0.78125 5.40009 0.78125C5.75195 0.78125 6.03821 1.06751 6.03821 1.41937L6.03821 2.93655C6.03821 3.28857 5.75195 3.57468 5.40009 3.57468Z",
  transform: "translate(0.0078125 14.566406)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.796814 0.398407C0.796814 0.178986 0.617828 0 0.398407 0C0.178986 0 0 0.178986 0 0.398407C0 0.617828 0.178986 0.796814 0.398407 0.796814C0.617828 0.796814 0.796814 0.617828 0.796814 0.398407Z",
  transform: "translate(0 8.786133)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0.398407C0 0.617828 0.178986 0.796814 0.398407 0.796814C0.617828 0.796814 0.796814 0.617828 0.796814 0.398407C0.796814 0.178986 0.617828 0 0.398407 0L0.398407 0C0.178986 0 0 0.178986 0 0.398407Z",
  transform: "translate(19.203125 3.9013672)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgMultimedia = function SvgMultimedia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultimedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multimedia.aaaa0ae4.svg";
export { ForwardRef as ReactComponent };